import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetPqrAlertHistory } from '../../../../../../services/pqr.service'; // ajusta según ruta
import { TableTooltip } from '../../../../../components/general/table';
import DateTimeFormat from '../../../../../components/dateTimeFormat';
import { PqrAlertHistory } from '../../../../../../shared/types/modules/pqr';
import { PqrAlertHistoryProps } from './props';
import { ISelect } from '../../../../../../shared/types/shared';

export const usePqrAlertHistory = ({ pqrId }: PqrAlertHistoryProps) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<PqrAlertHistory[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<PqrAlertHistory>[] = [
        {
            field: 'ruleNumber',
            headerName: 'ID Alerta',
            minWidth: 120,
            flex: 0.3,
            renderCell: (row) => (
                <TableTooltip
                    value={row.row?.alert?.ruleNumber?.toString() || ''}
                />
            ),
        },
        {
            field: 'alertByMail',
            headerName: 'Alerta por correo',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <>{row.row.alert?.alertSection?.alertByMail ? 'Si' : 'No'}</>
            ),
        },
        {
            field: 'emailOfficials',
            headerName: 'Destinatarios',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={row.row.alert?.alertSection?.emailOfficials || ''}
                />
            ),
        },
        {
            field: 'alertChangeStatus',
            headerName: 'Alerta cambia estado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <>{row.row.alert?.alertSection?.alertByMail ? 'No' : 'Si'}</>
            ),
        },
        {
            field: 'newStatus',
            headerName: 'Nuevo estado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={(row.row.alert?.newStatus as ISelect)?.name || ''}
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.createdAt} />,
        },
        {
            field: 'last_execution_at',
            headerName: 'Fecha de ultima ejecución',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => {
                const value = row.row.lastExecutionAt;
                if (!value) return '';
                return <DateTimeFormat dateAt={row.row.lastExecutionAt} />;
            },
        },
    ];
    useEffect(() => {
        if (pqrId) {
            setLoading(true);
            asyncGetPqrAlertHistory(pqrId, page, pageSize)
                .then((res) => {
                    setRows(res.items);
                    setTotal(res.length);
                })
                .finally(() => setLoading(false));
        }
    }, [page, pageSize, pqrId]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
